/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const orderBookStatus = {
  CLOSED: 'CLOSED',
  OPEN: 'OPEN',
  SUSPENDED: 'SUSPENDED',
  TESTING: 'TESTING',
} as const

export type OrderBookStatus = (typeof orderBookStatus)[keyof typeof orderBookStatus]
